// extracted by mini-css-extract-plugin
export var audioPlayer = "_u1-0";